export default "__VITE_ASSET__Duvqt6DX__"